async function loadBootstrap(): Promise<void> {
  try {
    await import('./bootstrap');
  } catch (err) {
    console.error(err);
  }
}

void loadBootstrap();
